export const exerciseOptions = {
  method: 'GET',
  headers: {
    'X-RapidAPI-Host': 'exercisedb.p.rapidapi.com',
    'X-RapidAPI-Key': process.env.REACT_APP_RAPID_API_KEY,
  },
};

export const youtubeoptions = {
  method: 'GET',
  headers: {
    'X-RapidAPI-Key': 'cdde46d95bmsh41fccc8bbaae6e5p13ed73jsn0d4decf25ac9',
    'X-RapidAPI-Host': 'youtube-search-and-download.p.rapidapi.com'
  }
};

export const fetchData = async(url,options) => {
    const response = await fetch(url,options);
    const data = await response.json();

    return data;
}